import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const upsertComponentSchema = yup.object().shape({
  component: yup
    .object()
    .shape({
      id: numberSchemaWithTransform().label(t('labelComponent')).nullable(),
      name: yup.string().label(t('labelComponent')).nullable().required(),
    })
    .label(t('labelComponent'))
    .nullable()
    .required(),
});
